module.exports = __webpack_public_path__ + "static/img/slaSurface2.de7f7fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slaSurface2.png
// module id = dxNV
// module chunks = 2